import {
  SET_TRANSACTION_RECONCILIATION,
  SET_TRANSACTION_RECONCILIATION_LOADER,
  SET_TRANSITION_DATE,
  SET_TRANSACTION_CHART
} from "./actionTypes";

const date = new Date();

const INIT_STATE = {
  reconciliation: {},
  transactionChart: {},
  defDate: {
    start_date: new Date(date.getFullYear(), date.getMonth(), 1 + 1)
      .toJSON()
      .split("T")[0],
    end_date: new Date(date.getFullYear(), date.getMonth() + 1, 0 + 1)
      .toJSON()
      .split("T")[0],
  },
  reconciliation_loader: false,
};

const transactions = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_TRANSACTION_RECONCILIATION:
      return {
        ...state,
        reconciliation: action.payload,
      };
    case SET_TRANSACTION_RECONCILIATION_LOADER:
      return {
        ...state,
        reconciliation_loader: !state.reconciliation_loader,
      };
    case SET_TRANSITION_DATE:
      return {
        ...state,
        defDate: action.payload,
      };
    case SET_TRANSACTION_CHART:
      return {
        ...state,
        transactionChart: action.payload,
      }
    default:
      return state;
  }
};

export default transactions;
